var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-green",on:{"click":_vm.print}},[_vm._v(" "+_vm._s(_vm.$t("Management.Handout.HandoutPrint"))+" "),_c('feather-icon',{attrs:{"icon":"FileIcon","size":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }